module.exports = __webpack_public_path__ + "img/fi-rr-building.d41b3ea5.svg";